export default __webpack_public_path__ + "static/media/Arch_Amazon-S3-Standard_64.ba185085.svg";